import { css, type Theme } from "@emotion/react";

import * as dimensions from "@styles/emotion-styles/dimensions";

export const filterAndSearch = css`
  width: 100%;
  margin-bottom: 2rem;
  min-height: 3rem;
  > div:first-of-type {
    flex-grow: 2;
  }
`;

export const container = css`
  display: flex;
  flex-direction: column;
`;

export const topRow = css`
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media (max-width: ${dimensions.phoneLargeMax}) {
    flex-direction: column; /* Stack elements vertically */
    align-items: flex-start; /* Align items to the left */
  }
`;

export const countDescription = css`
  padding-top: 10px;
  padding-bottom: 10px;
`;
export const titleSection = css`
  @media (min-width: ${dimensions.phoneLargeMax}) {
    margin-bottom: 1rem;
  }

  display: flex;
  align-items: center;
`;

export const filterButton = css`
  margin-right: 1rem;
`;

export const tagSection = (theme: Theme) => css`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  border-radius: ${dimensions.cardRadius};
  background-color: ${theme.system.backgroundMuted};
  margin-bottom: 1rem;
  padding: 1rem;
  min-height: 4.875rem;
`;

export const sortJustifyEnd = css`
  justify-content: flex-end;
`;
